
import {getCashiersProfile} from '../api/getCashiersProfile';
import {setGetCashiersProfileAction} from '../action';

const setGetCashiersProfile = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getCashiersProfile(params);

            if (data.status === 'success') {
                dispatch(setGetCashiersProfileAction({
                    data: data.data,
                    countPage: data.countPage
                }));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetCashiersProfile
}